import { useMemo, useState } from 'react';
import { STATS, TRENDS } from '@/mocks/trending';
import Bars from './Bars';

export default function Hero() {
  const [flash, setFlash] = useState(1);
  const preview = useMemo(() => {
    const pool = TRENDS.slice(0, 6);
    const offset = (flash - 1) % pool.length;
    const rotated = [...pool.slice(offset), ...pool.slice(0, offset)];
    return rotated.slice(0, 5).map((t, i) => ({ ...t, order: i + 1 }));
  }, [flash]);

  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-24 md:pt-32 pb-12 md:pb-16">
      <div
        className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-primary-100/70 blur-3xl"
        aria-hidden="true"
      ></div>
      <div
        className="pointer-events-none absolute -left-28 top-40 h-72 w-72 rounded-full bg-accent-100/80 blur-3xl"
        aria-hidden="true"
      ></div>

      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1.5 text-xs font-semibold text-accent-800">
            <i className="ri-radio-2-line" aria-hidden="true"></i>
            盯紧全网热门飙升 · 爆瓜预警第一时间触发
          </div>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            全网最热的瓜，
            <br />
            <span className="text-primary-500">快瓜</span>带你第一个吃到
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            实时聚合热榜与飙升话题，热度曲线一图看懂舆论风向。爆瓜预警、上升最快、
            分类追踪，吃瓜不必再满网翻墙找。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              查看实时热榜
              <i className="ri-arrow-down-line" aria-hidden="true"></i>
            </a>
            <a
              href="#rising"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-semibold text-foreground-800 transition hover:border-primary-300 hover:text-primary-600"
            >
              上升最快专区
              <i className="ri-rocket-2-line" aria-hidden="true"></i>
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-3 sm:grid-cols-4">
            {STATS.map((s) => (
              <div key={s.label} className="rounded-xl border border-background-200 bg-background-50/80 px-3 py-3 md:px-4 md:py-3.5">
                <dt className="text-[11px] text-foreground-500 md:text-xs">{s.label}</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {s.value}
                  <span className="ml-1 text-xs font-medium text-foreground-500">{s.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <div className="animate-float pointer-events-none absolute -right-2 -top-4 hidden md:block" aria-hidden="true">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1.5 text-xs font-bold text-background-50 shadow-sm">
              <i className="ri-fire-fill" aria-hidden="true"></i> LIVE
            </span>
          </div>
          <div className="rounded-2xl border border-background-200 bg-background-50/90 p-4 md:p-5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-timer-flash-line" aria-hidden="true"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">此刻热榜 · TOP5</p>
                  <p className="text-[11px] text-foreground-500">第 {flash} 轮刷新</p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setFlash((v) => v + 1)}
                className="inline-flex items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
                title="刷新榜单"
              >
                <i className="ri-refresh-line" aria-hidden="true"></i>刷新
              </button>
            </div>

            <ol className="mt-4 divide-y divide-background-100">
              {preview.map((t) => {
                const rankCls =
                  t.order === 1
                    ? 'bg-primary-500 text-background-50'
                    : t.order === 2
                      ? 'bg-primary-300 text-primary-950'
                      : t.order === 3
                        ? 'bg-accent-400 text-accent-950'
                        : 'bg-background-200 text-foreground-500';
                return (
                  <li key={t.id} className="flex items-center gap-3 py-2.5">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs font-bold ${rankCls}`}>
                      {t.order}
                    </span>
                    <p className="min-w-0 flex-1 truncate text-sm font-medium text-foreground-800">{t.title}</p>
                    <span className="hidden sm:block">
                      <Bars data={t.series} tone={t.order <= 2 ? 'primary' : 'accent'} />
                    </span>
                    <span className="w-16 shrink-0 text-right font-heading text-sm font-bold text-foreground-950">
                      {t.heat}
                    </span>
                  </li>
                );
              })}
            </ol>
            <a
              href="#hot"
              className="mt-3 inline-flex w-full items-center justify-center gap-1.5 rounded-lg bg-background-100 py-2.5 text-xs font-semibold text-foreground-700 transition hover:bg-background-200"
            >
              查看完整榜单
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}